<template>
  <div style="display: contents">
    <div class="asideBox-block">
      <recommendedLinks />
      <topRewards/>
      <mobileInfo />
    </div>
    <div class="betslip-block">
      <BetSlip ref="BetSlip"/>
    </div>
  </div>
</template>

<script>
  import topRewards from '@/components/sportsbook/widget/topRewards';
  import recommendedLinks from '@/components/sportsbook/widget/recommendedLinks'
  import mobileInfo from '@/components/sportsbook/widget/mobileinfo'
  import BetSlip from '@/components/sportsbook/BetSlip';
export default {
  name: "accountWidgets",
  components: {BetSlip, topRewards, recommendedLinks, mobileInfo}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/account/accountWidgets.vue